import { LayoutComponent } from "@jelly/lesson";

import * as original from "./simulation/original";
import * as improved from "./simulation/improved";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "controlsToggleExtraContent",
      options: {
        controls: [
          {
            type: "button",
            options: {},
            items: [{ name: "Original" }, { name: "Improved" }],
          },
        ],
        controlsPosition: "bottom",
        extraContent: [original.extraContent, improved.extraContent],
        components: [original.components, improved.components],
      },
    },
  },
];

export default components;
